import React from "react";
import image from "../../Assets/homeimgs/footerbg.png";
import { FaFacebook, FaLinkedin, FaTwitter } from "react-icons/fa";
// import logo from "../../Assets/logo/logo.svg";
import logo from "../../Assets/logo/OtL.png";
import { MdAttachEmail } from "react-icons/md";
import { IoCall, IoLocation } from "react-icons/io5";
import { FaSquareInstagram } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import pdf1 from "../../pdf/GST.pdf";
import pdf2 from "../../pdf/OTLCS.pdf";
import pdf3 from "../../pdf/SPICE.pdf";
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <footer
        className="footer-bg py-10 bg-cover bg-center mt-10 text-white"
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="grid grid-cols-1 md:grid-cols-4 mx-8 md:mx-16 gap-10 md:gap-16">
          <div className="">
            <div className="flex">
              <img className="w-20 object-cover" src={logo} alt="logo" />
              <h2 className="text-center"></h2>
            </div>
            <p className="text-gray-400 text-base md:text-md mb-3">
              RailVest offers a seamless avenue for establishing a cutting-edge
              investment platform without necessitating coding expertise within
              a short time.
            </p>
            <div className="flex space-x-4 text-[#12D2EC]">
              <FaSquareInstagram />
              <FaFacebook />
              <FaLinkedin />
              <FaTwitter />
            </div>
          </div>
          <div className="flex flex-col gap-3 text-sm text-gray-400">
            <h1 className="text-xl mb-3  text-white ">
              Quick links
              <div class="w-1/5 pb-1  border-b-2 border-[#12D2EC]"></div>
            </h1>

            <div className="text-gray-400 text-base md:text-md mb-3 flex flex-col space-y-2">
              <span
                className="cursor-pointer"
                onClick={() => {
                  navigate("/");
                  window.scrollTo(600, 0);
                }}
              >
                Home
              </span>
              <span
                className="cursor-pointer"
                onClick={() => {
                  navigate("/about");
                  window.scrollTo(600, 0);
                }}
              >
                About
              </span>
              <span
                className="cursor-pointer"
                onClick={() => {
                  navigate("/services");
                  window.scrollTo(600, 0);
                }}
              >
                Services
              </span>
              <span
                className="cursor-pointer"
                onClick={() => {
                  navigate("/sectors");
                  window.scrollTo(600, 0);
                }}
              >
                Sectors
              </span>
              <span
                className="cursor-pointer"
                onClick={() => {
                  navigate("/careers");
                  window.scrollTo(600, 0);
                }}
              >
                Careers
              </span>

              {/* <span
                className="cursor-pointer"
                onClick={() => {
                  navigate("/projects");
                  window.scrollTo(600, 0);
                }}
              >
                Projects
              </span> */}
              <span
                className="cursor-pointer"
                onClick={() => {
                  navigate("/contact");
                  window.scrollTo(600, 0);
                }}
              >
                Contact
              </span>
            </div>
          </div>
          <div className="flex flex-col gap-3 text-sm text-gray-400">
            <h1 className="text-xl mb-3 text-white">
              Information
              <div class="w-1/6 md:w-2/6 pb-1  border-b-2 border-[#12D2EC]"></div>
            </h1>
            {/* <div className="text-gray-400 text-base md:text-md mb-3 flex flex-col space-y-2">
              <span><a href="../../Assets/logo/OTLCS PVT LTD GST.pdf"  download>Otlcs Pvt Ltd Gst</a></span>
              <span><a href="../../Assets/logo/OTLCS PVT LTD PAN.pdf"  download>Otlcs Pvt Ltd Pan</a></span>
              <span><a href="../../Assets/logo/SPICE + Part B_Approval Letter_AA7876596.pdf"  download>Approval Letter</a></span>
            </div> */}
            <div className="text-gray-400 text-base md:text-md mb-3 flex flex-col space-y-2">
              <a href={pdf1} download="GST.pdf">
                Download Otlcs Pvt Ltd GST
              </a>

              <a href={pdf2} download="OTLCS.pdf">
                Download Otlcs Pvt Ltd PAN
              </a>

              <a href={pdf3} download="SPICE.pdf">
                Download Approval Letter
              </a>
            </div>
          </div>
          <div className="flex flex-col gap-3 text-sm text-gray-400">
            <h1 className="text-xl mb-3 text-white">
              Contact Us
              <div class="w-3/12 pb-1  border-b-2 border-[#12D2EC]"></div>
            </h1>

            <div className="text-gray-400 text-base md:text-md mb-3 flex flex-col space-y-2">
              <div className="flex items-center space-x-2">
                <MdAttachEmail />
                <span>otl.civil@gmail.com</span>
              </div>

              <div className="flex items-center space-x-2 ">
                <IoCall />
                <span>(0674) 7965811</span>
              </div>
              <div className="flex items-center space-x-2 ">
                <span className="shrink-0">
                  <IoLocation />{" "}
                </span>
                <span>
                  Plot No: 822,B3, Kalinga Nagr Ghatikia, Bhubaneswar, 751003
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="py-4 bg-[#0D166C] text-white">
        <div className="md:mx-16 px-4 flex flex-wrap justify-between items-center">
          <p className="w-full sm:w-auto text-center sm:text-left">
            © Copyright {currentYear}, OTL . All Rights Reserved.
          </p>
          <p className="w-full sm:w-auto text-center sm:text-right">
            Design & Developed by{" "}
            <a
              href="https://www.webbocket.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              WEB_BOCKET
            </a>
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Footer;
